import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { permissonsByRoles } from "../../helpers/utils/permissonsByRoles";
import { connect } from "react-redux";
import { publicRoutes } from "../../helpers/utils/publicRoutes";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  userRoles,
  loadingRoles,
  children,
}) => {
  const location = useLocation();

  const checkRoleUser = () => {
    const urlAtual = location.pathname.replace("/", "");

    if (publicRoutes.some(route => route === urlAtual)) {
      return false;
    }

    const allowedRoles = permissonsByRoles[urlAtual] || [];

    const isAuth = allowedRoles.some((role) => userRoles.includes(role));

    return !isAuth;
  };

  if(!isAuthProtected) {
    return <Layout>{children}</Layout>;
  }

  if (loadingRoles) {
    return (
      <Layout>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: "400px", width: "100%" }}
                    >
                      <Spinner
                        color="primary"
                        style={{ height: "5rem", width: "5rem" }}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>
    );
  }

  if (isAuthProtected && (userRoles === null || checkRoleUser())) {
    return (
      <Layout>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <p>User not authorized to access this page.</p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>
    );
  }

  return <Layout>{children}</Layout>;
};

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

const mapStateToProps = ({ RolesReducer: { loadingRoles } }) => ({
  loadingRoles,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Authmiddleware);
